__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "unity_provectus_aiConduct";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "4.30.0", () => (__webpack_require__.e(561).then(() => (() => (__webpack_require__(7561))))));
			register("@azure/msal-react", "3.0.29", () => (Promise.all([__webpack_require__.e(810), __webpack_require__.e(283), __webpack_require__.e(405)]).then(() => (() => (__webpack_require__(6810))))));
			register("@unity/auth-lib", "3.0.1", () => (Promise.all([__webpack_require__.e(105), __webpack_require__.e(283), __webpack_require__.e(405), __webpack_require__.e(351)]).then(() => (() => (__webpack_require__(1105))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(118), __webpack_require__.e(283), __webpack_require__.e(205)]).then(() => (() => (__webpack_require__(3118))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("zustand", "5.0.12", () => (Promise.all([__webpack_require__.e(283), __webpack_require__.e(618)]).then(() => (() => (__webpack_require__(5618))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};